import mapFunction from './mapResources';

export default mapFunction('entity_operations', {
    isFetching: false,
    items: [] 
});
